/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `NONE` - None
 * * `QUEUED` - Queued
 * * `RUNNING` - Running
 * * `SUCCEEDED` - Succeeded
 * * `FAILED` - Failed
 * @export
 */
export const ActionStatusEnum = {
    None: 'NONE',
    Queued: 'QUEUED',
    Running: 'RUNNING',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED'
} as const;
export type ActionStatusEnum = typeof ActionStatusEnum[keyof typeof ActionStatusEnum];


export function instanceOfActionStatusEnum(value: any): boolean {
    for (const key in ActionStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(ActionStatusEnum, key)) {
            if (ActionStatusEnum[key as keyof typeof ActionStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActionStatusEnumFromJSON(json: any): ActionStatusEnum {
    return ActionStatusEnumFromJSONTyped(json, false);
}

export function ActionStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionStatusEnum {
    return json as ActionStatusEnum;
}

export function ActionStatusEnumToJSON(value?: ActionStatusEnum | null): any {
    return value as any;
}

export function ActionStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ActionStatusEnum {
    return value as ActionStatusEnum;
}

